import * as React from 'react'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import TableCheckbox from '@/modules/drivers/shared/tableItems/TableCheckbox'

export const DriverInGroupRow = ({
  driver,
  selectedIds,
  toggleId,
}: {
  driver: any
  selectedIds: number[]
  toggleId: (id: number, checked: boolean) => void
}) => {

  const isChecked = selectedIds.includes(driver?.id)
  const isActive = driver?.isActive
  const [isHovered, setIsHovered] = React.useState(false)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)
  return (
    <tr
      className={`notches-border--right tw-w-fit tw-border-b tw-bg-white hover:tw-bg-primary/10`}
      onClick={() => toggleId(driver?.id, isActive)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <TableCheckbox
        disabled={false}
        checked={isChecked}
        onChange={() => toggleId(driver.id, isActive)}
        isHovered={isHovered}
      />
      <TableTextRow size="small">{`${driver?.fullName}`}</TableTextRow>
      <TableTextRow size="small">
        {driver?.driverCard?.cardNumber.value ?? '-'}
      </TableTextRow>
      <TableTextRow size="small">
        {driver?.workPermitStartDate ?? '-'}
      </TableTextRow>
    </tr>
  )
}
